<template>
	<c-card color="#85afff">
		<h4 slot="title">
			<v-icon>mdi-ruler</v-icon>
			HTM/MNS
		</h4>
		<form @submit.prevent="onSubmit">
			<cols-row v-if="authIsAdmin" md="12">
				<recheck-select :required="true" v-model="form.recheck"></recheck-select>
			</cols-row>
			<template v-if="form.recheck === 'HTM'">
				<cols-row md="12">
					<HTMSelect v-model="form.note"></HTMSelect>
				</cols-row>
			</template>
			<template v-if="form.recheck === 'MNS'">
				<cols-row md="12">
					<smart-input :textarea="true" :rows="3" v-model="form.note"
						:label="$t('pages.htmForm.reasonToCancel')"/>
					<drag-and-drop
						:removedFiles="removedFiles"
						:key="measurement.id"
						:files="form.files"
						:inputId="measurement.id"
						:name="`files-${measurement.id}[]` "></drag-and-drop>
				</cols-row>
			</template>
			<c-col>
			</c-col>
			<c-col>
				<btn-loader :progress="inProgress" type="submit" class="primary">{{$t("attributes.save")}}</btn-loader>
			</c-col>
		</form>
	</c-card>
</template>

<script>
	import CCard from "dev/scaffoldings/cCard";
	import RecheckSelect from "dev/view/orders/RecheckSelect";
	import {types as MeasurementType} from "dev/store/modules/Measurement.module";
	import BtnLoader from "dev/components/BtnLoader";
	import HTMSelect from "./HTMSelect";
	import DragAndDrop from "dev/components/DragNDrop";

	export default {
		name: "htm-form",
		props: {},
		components: {DragAndDrop, BtnLoader, RecheckSelect, CCard, HTMSelect},
		data() {
			return {
				form: {
					note: null,
					recheck: "MNS",
					reason: null,
					files: [],
				},
				removedFiles: [],
				inProgress: false,
			};
		},
		computed: {
			measurement() {
				return this.$store.state.MeasurementModule.measurement;
			},
			authIsAdmin() {
				return this.$store.getters.isAdmin;
			},
		},
		methods: {

			async onSubmit() {
				this.inProgress = true;
				try {
					let formData = new FormData();
					formData.append("measurement", this.measurement.id);
					formData.append("deleted_at", this.measurement.deleted_at);
          if (this.form.note) {
            formData.append("note", this.form.note);
          }
					formData.append("recheck", this.form.recheck);
					if (this.form.reason){
            formData.append("reason", this.form.reason);
          }
					if(this.removedFiles){
						this.removedFiles.forEach((id,index) => {
							if(id){
								formData.append("fileRemoveId[]",id);
							}
						});
					}
					if (this.form.files) {
						this.form.files.forEach((f, x) => {
							if (!f.id) {
								formData.append(`files-${this.measurement.id}[]`, f);
							}

						});
					}
					await this.$store.dispatch(
						MeasurementType.DUPLICATE,
						{id: this.measurement.id, form: formData}
					);
					this.$notfication.success("ההזמנה נוספה לעמוד ההזמנות!");
					this.$emit("save");
				} catch (e) {
					this.inProgress = false;
					this.$notfication.error();

				}


			}
		},
		created() {
			this.form.files = this.measurement.files.slice(0);
		}
	};
</script>

<style scoped>

</style>
